import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	thirdPartySourceHeader: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.source-group.third-party-source-header',
		defaultMessage: 'Where would you like to import from?',
		description: 'The header for third-party sources',
	},
	thirdPartySourceDescription: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.source-group.third-party-source-description',
		defaultMessage: 'Select the app where you’d like to import your data from.',
		description: 'The Description for third-party sources',
	},
	csvSectionHeader: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.source-group.csv-section-header',
		defaultMessage: 'Can’t find your app?',
		description: 'The Header for the Any CSV',
	},
	csvSectionDescription: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.source-group.csv-section-description',
		defaultMessage:
			'If you don’t see your app here, select <strong>CSV</strong> to use any CSV file to import your data.',
		description: 'The Description for the Any CSV',
	},
	showMore: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.source-group.show-more',
		defaultMessage: 'Show more apps',
		description: 'The Description for show more button',
	},
});
